import { useTranslation } from "@msuite/ui/localization";
import { Tag } from "@msuite/ui/tag";
import { Link } from "react-router";

/** Props Interface */
interface IncomingInvoiceDuplicateTagProps {
	original: { id: string; number: string | null };
}

/** That the invoice repeats an earlier one, linking to it. */
export function IncomingInvoiceDuplicateTag({ original }: IncomingInvoiceDuplicateTagProps) {
	/** Context */
	const { t } = useTranslation();

	/** Render */
	return (
		<Link
			to={`/controlling/incoming-invoices/${original.id}`}
			data-cy="incoming-invoice-duplicate-tag"
		>
			<Tag
				size="xs"
				color="rose"
				variant="plain"
			>
				{t("incoming_invoices.check_hints.duplicate_of", { number: original.number ?? "–" })}
			</Tag>
		</Link>
	);
}
